var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { languageMap } from "../../../../constants/Language";
import liveCasinoGamesRu from "../../../../assets/img/slider-banners/jacktop-games/live-casino-games-ru.png";
import liveCasinoGamesEn from "../../../../assets/img/slider-banners/jacktop-games/live-casino-games-en.png";
import tryNewRu from "../../../../assets/img/slider-banners/jacktop-games/try-new-ru.png";
import tryNewEn from "../../../../assets/img/slider-banners/jacktop-games/try-new-en.png";
import jacktopBannerLogo from "../../../../assets/img/slider-banners/jacktop-games/jacktop-banner-logo.png";
import jacktopBannerGirl from "../../../../assets/img/slider-banners/jacktop-games/jacktop-banner-girl.png";
import { isStage } from "../../../../shared/domainUtils";
var liveCasinoGames = {
    ru: liveCasinoGamesRu,
    en: liveCasinoGamesEn,
};
var tryNew = {
    ru: tryNewRu,
    en: tryNewEn,
};
var getBannerLocale = function (locale) { return (locale === "ru" ? "ru" : "en"); };
var JacktopGamesBanner = /** @class */ (function (_super) {
    __extends(JacktopGamesBanner, _super);
    function JacktopGamesBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var isActiveSlide = _this.props.isActiveSlide;
            if (isActiveSlide)
                _this.props.push("games", {
                    provider: isStage ? 142 : 679,
                });
        };
        return _this;
    }
    JacktopGamesBanner.prototype.render = function () {
        var langId = this.props.langId;
        var locale = getBannerLocale(languageMap[langId].name);
        return (_jsxs("div", __assign({ className: "jacktop-games-banner", onClick: this.onClick }, { children: [_jsx("img", { src: tryNew[locale], alt: "Try new Games" }), _jsx("img", { src: liveCasinoGames[locale], alt: "Try new Games" }), _jsx("img", { src: jacktopBannerLogo, alt: "Logo" }), _jsx("img", { src: jacktopBannerGirl, alt: "Jacktop girl" })] })));
    };
    return JacktopGamesBanner;
}(Component));
var mapStateToProps = function (state) {
    return {
        langId: state.application.get("languageId"),
    };
};
export default connect(mapStateToProps, { push: push })(JacktopGamesBanner);



// WEBPACK FOOTER //
// ./src/components/slider-banner/banners/jacktop-games/JacktopGamesBanner.jsx